<template>
	<ProductDetails
		:product-details-blok="blok"
		:size-guide-tab="sizeGuideTab"
		:washing-instructions-tab="washingInstructionsTab"
	/>
</template>

<script setup lang="ts">
import ProductDetails from "~/components/Product/ProductDetails/ProductDetails.vue";
import type {
	BlokProductDetails,
	BlokSizeGuideTab,
	BlokWashingInstructionsTab
} from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokProductDetails;
	sizeGuideTab?: BlokSizeGuideTab;
	washingInstructionsTab?: BlokWashingInstructionsTab;
}

defineProps<Props>();
</script>
